import React from 'react'
import Svg, { SvgProps } from '@/components/svg'
import iconAllproperty from '../build/icon-allproperty'

export const IconAllproperty: React.FC<Omit<SvgProps, 'src'>> = (props) => {
  return <Svg {...props} src={iconAllproperty} />
}

export default IconAllproperty
